var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.as,
    {
      tag: "component",
      staticClass: "gfu-link-underline",
      on: { click: _vm.onClick },
    },
    [
      _vm.isIconBeforeVisible
        ? _c("base-icon", { staticClass: "_mr-h", attrs: { name: _vm.icon } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "gfu-link-underline__content" },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.isIconAfterVisible
        ? _c("base-icon", { staticClass: "_ml-h", attrs: { name: _vm.icon } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }